import { Pot } from '@aslanpay/portal-common-lib';

import { GroupTreeNodeComplete, GroupWithPot } from '../../hooks/useGroupsWithPot/types';

/**
 * @description This function formats the groups and their respective pots
 */
function formatGroupWithPots(groups: GroupTreeNodeComplete[], pots: Pot[]): GroupWithPot[] {
  const potByRelatedId = new Map<string, Pot>();
  pots.forEach((pot) => {
    if (pot.relatedId != null && !potByRelatedId.has(pot.relatedId)) {
      potByRelatedId.set(pot.relatedId, pot);
    }
  });

  const format = (nodes: GroupTreeNodeComplete[]): GroupWithPot[] => {
    return nodes.map((group) => {
      return {
        ...group,
        pot: potByRelatedId.get(group.id),
        children: group.children ? format(group.children) : [],
      };
    });
  };

  return format(groups);
}

/**
 *
 * @description Generate the full display name for a group, with the possibility to skip the first parent
 * @example
    { name: 'Company 1', children: [
      { name: 'Hotel A', children: [
        { name: 'Marketing', children: [
          { name: 'Junior Marketing', children: [] }
        ] }
      ] },
      { name: 'Hotel B', children: [] }
    ] }

    With startOn = 1 (default):   Junior Marketing (Hotel A > Marketing)
    With startOn = 0:             Junior Marketing (Company 1 > Hotel A > Marketing)
    With includeParents = false:  Junior Marketing
 *
*/
function getGroupDisplayNameWithParents(
  group: GroupWithPot | GroupTreeNodeComplete,
  props: { startOn?: number; includeParents?: boolean } = {}
): string {
  const { startOn = 1, includeParents = true } = props;

  if (group.parents && group.parents.length > startOn && includeParents) {
    return `${group.name} (${group.parents.slice(startOn).join(' > ')})`;
  }

  return group.name;
}

export { getGroupDisplayNameWithParents, formatGroupWithPots };
